import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="flex items-center justify-center w-full min-h-screen">
      <div className="text-center w-full">
        <h1 className="font-bold text-6xl text-primary">404</h1>
        <h1>Ooops, Page not found. </h1>
        <Link to="/" className="text-primary text-sm underline">
          Go back home
        </Link>
      </div>
    </div>
  );
}
